// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0a0e27 0%, #1a2847 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.login-box {
  background: rgba(20, 25, 45, 0.9);
  border: 1px solid rgba(0, 255, 200, 0.1);
  border-radius: 12px;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  margin: 0;
  font-size: 32px;
  color: #00ffc8;
  font-weight: 700;
}

.login-header p {
  margin: 8px 0 0 0;
  color: rgba(0, 255, 200, 0.6);
  font-size: 14px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #e0e7ff;
  font-weight: 500;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(0, 255, 200, 0.2);
  border-radius: 8px;
  background: rgba(0, 255, 200, 0.05);
  color: #e0e7ff;
  font-size: 16px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: rgba(0, 255, 200, 0.5);
  background: rgba(0, 255, 200, 0.1);
  box-shadow: 0 0 0 3px rgba(0, 255, 200, 0.1);
}

.form-group input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-group small {
  display: block;
  margin-top: 6px;
  color: rgba(224, 231, 255, 0.6);
  font-size: 12px;
}

.form-group small.expired {
  color: #ff6b6b;
}

.login-container button {
  width: 100%;
  padding: 12px 16px;
  margin-top: 16px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #00ffc8 0%, #00d4aa 100%);
  color: #0a0e27;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.login-container button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 255, 200, 0.3);
}

.login-container button:active:not(:disabled) {
  transform: translateY(0);
}

.login-container button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.secondary-btn,
.back-btn {
  background: transparent;
  border: 1px solid rgba(0, 255, 200, 0.3);
  color: #00ffc8;
  margin-top: 12px;
}

.secondary-btn:hover:not(:disabled),
.back-btn:hover:not(:disabled) {
  background: rgba(0, 255, 200, 0.05);
  border-color: rgba(0, 255, 200, 0.5);
}

.error-message {
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  color: #ff6b6b;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

.success-message {
  background: rgba(0, 255, 200, 0.1);
  border: 1px solid rgba(0, 255, 200, 0.3);
  color: #00ffc8;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 255, 200, 0.1);
}

.login-footer p {
  margin: 0;
  color: rgba(224, 231, 255, 0.5);
  font-size: 13px;
}

@media (max-width: 480px) {
  .login-box {
    padding: 30px 20px;
  }

  .login-header h1 {
    font-size: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,+EAA+E;AACjF;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #0a0e27 0%, #1a2847 100%);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.login-box {\n  background: rgba(20, 25, 45, 0.9);\n  border: 1px solid rgba(0, 255, 200, 0.1);\n  border-radius: 12px;\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-header h1 {\n  margin: 0;\n  font-size: 32px;\n  color: #00ffc8;\n  font-weight: 700;\n}\n\n.login-header p {\n  margin: 8px 0 0 0;\n  color: rgba(0, 255, 200, 0.6);\n  font-size: 14px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #e0e7ff;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid rgba(0, 255, 200, 0.2);\n  border-radius: 8px;\n  background: rgba(0, 255, 200, 0.05);\n  color: #e0e7ff;\n  font-size: 16px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: rgba(0, 255, 200, 0.5);\n  background: rgba(0, 255, 200, 0.1);\n  box-shadow: 0 0 0 3px rgba(0, 255, 200, 0.1);\n}\n\n.form-group input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 6px;\n  color: rgba(224, 231, 255, 0.6);\n  font-size: 12px;\n}\n\n.form-group small.expired {\n  color: #ff6b6b;\n}\n\n.login-container button {\n  width: 100%;\n  padding: 12px 16px;\n  margin-top: 16px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #00ffc8 0%, #00d4aa 100%);\n  color: #0a0e27;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.login-container button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 255, 200, 0.3);\n}\n\n.login-container button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-container button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.secondary-btn,\n.back-btn {\n  background: transparent;\n  border: 1px solid rgba(0, 255, 200, 0.3);\n  color: #00ffc8;\n  margin-top: 12px;\n}\n\n.secondary-btn:hover:not(:disabled),\n.back-btn:hover:not(:disabled) {\n  background: rgba(0, 255, 200, 0.05);\n  border-color: rgba(0, 255, 200, 0.5);\n}\n\n.error-message {\n  background: rgba(255, 107, 107, 0.1);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  color: #ff6b6b;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.success-message {\n  background: rgba(0, 255, 200, 0.1);\n  border: 1px solid rgba(0, 255, 200, 0.3);\n  color: #00ffc8;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(0, 255, 200, 0.1);\n}\n\n.login-footer p {\n  margin: 0;\n  color: rgba(224, 231, 255, 0.5);\n  font-size: 13px;\n}\n\n@media (max-width: 480px) {\n  .login-box {\n    padding: 30px 20px;\n  }\n\n  .login-header h1 {\n    font-size: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
